import { IconButton } from 'component/Button/IconButton'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import css from 'page/InferenceScreen/MessagePanel.module.scss'
import { store } from 'store/store'

export const MessagePanel = observer(() => {
  const message = store.carousel?.message

  const onCancel = useLatestCallback(async () => {
    store.carousel.message = undefined
  })

  if (!message) return null

  return <Space className={css.panel}>
    <Typo size={13}>
      {message.text}
    </Typo>
    <IconButton link xs action={onCancel}>
      <Icon size={16} name="close" secondary />
    </IconButton>
  </Space>
})
